import { render } from "./FormSchedule.vue?vue&type=template&id=5160a5aa&scoped=true"
import script from "./FormSchedule.vue?vue&type=script&lang=js"
export * from "./FormSchedule.vue?vue&type=script&lang=js"

import "./FormSchedule.vue?vue&type=style&index=0&id=5160a5aa&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5160a5aa"]])

export default __exports__